import React, { Component } from 'react';

import NoteList from 'components/NoteList/NoteList';
import Pagination from 'components/Pagination/Pagination';
import getCarrier from 'helpers/getCarrier';
import { getSubStatus } from '../../helpers/subs';
import { toast } from 'react-toastify';
import FormError from 'components/FormError';
import { prettyKey } from 'helpers/formatters';
import Spinner from 'components/Spinner';
import { hasComma } from 'helpers/validators';
import SimoScheduledActions from 'containers/simo/SimoScheduledActions';
import QuickPortData from 'components/quick/PortData';

class ViewSub extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      simoUsageBalance: null,
      wasLoadedSimoUsageBalance: false,
    };
  }

  componentDidMount() {
    const { subId, sub, fetchSubContract } = this.props;

    fetchSubContract && fetchSubContract(subId);

    if (sub) {
      this.loadSubExtraData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { sub } = this.props;
    if (!prevProps.sub && sub) {
      this.loadSubExtraData();
    } else if (!this.state.wasLoadedSimoUsageBalance && sub) {
      this.loadSimoUsage();
    }
  }

  loadSubExtraData = () => {
    const {
      sub,
      subId,
      fetchAllServiceCodes,
      fetchServiceCodes,
      fetchRunningActions,
      fetchPortData,
    } = this.props;

    const isAtt = getCarrier(sub) === 'att';
    const isQuick = getCarrier(sub) === 'quick';
    const isAttBypassed = isAtt && !sub.synced_with_att;
    const subStatus = getSubStatus(sub);
    const notExpired = subStatus !== 'expired';

    if (notExpired && !isAttBypassed) {
      fetchAllServiceCodes && fetchAllServiceCodes();
      fetchServiceCodes && fetchServiceCodes(subId);
      fetchRunningActions && fetchRunningActions(subId);
      this.loadSimoUsage();
    }

    const statusesForPortData = [
      'port_valid',
      'port_open',
      'port_conflict',
      'port_cancelled',
      'port_completed',
      'port_confirmed',
      'port_denied',
      'port_error',
    ];
    if (isQuick && statusesForPortData.includes(subStatus)) {
      fetchPortData(subId);
    }
  };

  handleUpdateField = (name, value) => {
    const { updateSub, sub } = this.props;

    if (
      ['first_name', 'last_name'].includes(name) &&
      (!value || !value.trim())
    ) {
      toast.error(`${prettyKey(name)} cannot be empty`);
      return;
    }

    if (['first_name', 'last_name'].includes(name) && hasComma(value)) {
      toast.error(`${prettyKey(name)}: comma sign is not allowed`);
      return;
    }

    this.setState({ loading: true });
    updateSub(sub.id, { [name]: value })
      .then(() => {
        toast.success(`${prettyKey(name)} updated`);
        this.setState({ loading: false });
      })
      .catch((e) => {
        if (e.errors) {
          let transformedError = e.errors;
          const keys = Object.keys(transformedError);
          keys.forEach((key) => {
            if (Array.isArray(transformedError[key])) {
              transformedError[key] = transformedError[key].join('; ');
            }
          });
          toast.error(<FormError error={transformedError} />);
        } else {
          toast.error(<FormError error={e} />);
        }
        this.setState({ loading: false });
      });
  };

  loadSimoUsage() {
    const { sub, subId, fetchSimoUsageBalance } = this.props;

    const isSimo = getCarrier(sub) === 'simo';
    const subStatus = getSubStatus(sub);
    const isActive = subStatus === 'active';
    if (isSimo && isActive) {
      this.setState({ wasLoadedSimoUsageBalance: true });
      fetchSimoUsageBalance(subId)
        .then((response) => this.setState({ simoUsageBalance: response.data }))
        .catch((e) => console.log(e));
    }
  }

  render() {
    const {
      fetchAllServiceCodes,
      sub,
      portData,
      notFound,
      findSub,
      pageCount,
      page,
      isAdminOrManagerOrBusiness,
      isAdminOrManagerOrBillingOrReseller,
      isReseller,
      pageUrl,
      Sub,
      SubActions,
      isAdminOrAgentOrBillingOrManager,
      ...props
    } = this.props;
    const { simoUsageBalance, loading } = this.state;

    if (notFound) {
      return <div>Not Found</div>;
    }
    if (!sub) {
      return <div>Loading...</div>;
    }

    const carrier = getCarrier(sub);

    return (
      <React.Fragment>
        {SubActions && (
          <SubActions
            sub={sub}
            user={props.user}
            subServiceCodes={this.props.subServiceCodes}
            loggedInUser={props.loggedInUser}
          />
        )}
        <div className="relative">
          <Sub
            {...props}
            sub={sub}
            simoUsageBalance={simoUsageBalance}
            handleUpdateField={this.handleUpdateField}
          />
          {portData && <QuickPortData portData={portData} />}
          <Spinner showLoader={loading} />
        </div>
        {carrier === 'simo' && (
          <SimoScheduledActions sub={sub} findSub={findSub} />
        )}
        <NoteList {...props} subId={sub.id} carrier={carrier} />
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) => pageUrl(sub.id, pageNum)}
        />
      </React.Fragment>
    );
  }
}

export default ViewSub;
